// src/components/Landing.js
import React from "react";
import "./main.css"; // Assuming styles are here
import ReactTypingEffect from 'react-typing-effect'; // Import the typing effect component
// Removed useParams import as discount comes from props
import Trending from "./Trending"; // Component for trending products
import Your from "./Your"; // Component for interested products
import ProductList from "./ProductList"; // Component for the product grid
import CategorySection from "./CategorySection"; // New component for categories
import About from "./about.jpg"; // Path to the about image
import Bubble1 from "./memory.jpg"
import Bubble2 from "./bubble2.jpeg"
import Bubble3 from "./bubble3.png"
// Receive customerDiscount and loggedInCustomerCode as props from App.js
const Landing = ({ customerDiscount, loggedInCustomerCode }) => {

  

  // Use the customerDiscount prop directly
  const discountPercent = customerDiscount;

  return (
    // The main container for the landing page content
    // No tophead or header here, as they are now global in App.js
    <div>
      {/* Hero Section */}
      <section className="home" id="home">
        <div className="hero-content">
          <h1>
            <ReactTypingEffect
              text={["Premium Memory Foam.", "Exceptional Comfort.", "Superior Quality.", "Innovative Design."]}
              speed={100}
              eraseSpeed={100}
              typingDelay={300}
              eraseDelay={1800}
              cursorRenderer={cursor => <span className="typing-cursor">{cursor}</span>}
            />
          </h1>
          <p>Elevating comfort through innovative memory foam solutions. Crafted with precision for mattresses, pillows, and custom applications — delivering excellence with every product.</p>
          <div className="hero-buttons">
            <a href="/products" className="btn">Browse Products</a>
            <a href="#contact" className="btn hero-contact-btn">Get in Touch</a>
          </div>
        </div>
        <div className="hero-bubbles">
          <div className="bubble bubble-1">
            <img src={Bubble1} alt="Memory foam product" />
          </div>
          <div className="bubble bubble-2">
            <img src={Bubble2} alt="Memory foam application" />
          </div>
          <div className="bubble bubble-3">
            <img src={Bubble3} alt="Memory foam close-up" />
          </div>
        </div>
      </section>

      {/* Trending Products Section */}
      {/* Pass the customer's discount percentage to the Trending component */}
      <Your discount={discountPercent} loggedInCustomerCode={loggedInCustomerCode} />

      <Trending discount={discountPercent} />

      {/* Your Interested Products Section */}
      {/* Pass both discount and loggedInCustomerCode to the Your component */}

      {/* Categories Section */}
      <section id="Categories"> 
        <CategorySection  /></section>
     

      {/* About Us Section */}
      <section className="about" id="about">
        <h1 className="heading"> <span> about </span> us </h1>
        <div className="row">
          <div className="video-container"> {/* Consider renaming if it's just an image */}
            <img src={About} alt="About Amcouch Manufacturing" />
            {/* Removed empty h3 */}
          </div>
          <div className="content">
            <h3>Leading memory foam manufacturers</h3>
            <p>
              At AMCOUCH, we are a leading memory foam manufacturer based in Gurgaon, dedicated to delivering comfort through innovation. With a focus on quality, durability, and ergonomic design.
            </p>
            <p>
              Our products are crafted using advanced manufacturing processes and premium-grade materials. Whether for mattresses, pillows, or customized foam solutions, we cater to both B2B and B2C needs, ensuring restful sleep and enhanced well-being. Proudly made in India, our foam is trusted by top mattress brands and discerning customers nationwide.
            </p>
            {/* "Learn More" button - link destination might need adjustment */}
            <a href="#contact" className="btn"> learn more </a>
          </div>
        </div>
      </section>

      {/* Our Products Section (showing a limited list on landing) */}
      <section className="products" id="products">
        <h1 className="heading"> Our <span>Products</span> </h1>
        {/* Pass the customer's discount percentage to the ProductList component */}
        {/* Ensure initialLimit is appropriate for the landing page */}
        <ProductList initialLimit={10} customerDiscount={discountPercent} />
      </section>

      {/* Customer Review Section */}
      <section className="review" id="review">
        <h1 className="heading"> customer's <span>review</span> </h1>
        <div className="box-container">
          {/* Box 1 */}
          <div className="box">
            <div className="stars">
              <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
            </div>
            <p>
              We've partnered with this manufacturer for over two years, and their memory foam quality has been consistently excellent. Our end products have seen a noticeable boost in customer satisfaction, and their team is always responsive and professional.
            </p>
            <div className="user">
              <img src="images/pic-1.png" alt="" /> {/* Ensure image paths are correct */}
              <div className="user-info">
                <h3>Vikram Sethi</h3>
                <span>happy customer</span>
              </div>
            </div>
            <span className="fas fa-quote-right"></span>
          </div>
          {/* Box 2 */}
          <div className="box">
            <div className="stars">
               <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
            </div>
            <p>
              "The foam quality, customization options, and timely delivery have made them our go-to supplier. Their material performs well in both mattresses and cushions, and we've received great feedback from our retail partners."
            </p>
            <div className="user">
              <img src="images/pic-2.png" alt="" /> {/* Ensure image paths are correct */}
              <div className="user-info">
                <h3>Neha Arora</h3>
                <span>happy customer</span>
              </div>
            </div>
            <span className="fas fa-quote-right"></span>
          </div>
          {/* Box 3 */}
          <div className="box">
             <div className="stars">
               <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
            </div>
            <p>
              "We needed a reliable supplier for high-density memory foam for our orthopedic mattress line. The team delivered exactly what we needed—great density, perfect resilience, and solid durability. Highly recommend for anyone in the sleep or furniture business."
            </p>
            <div className="user">
               <img src="images/pic-3.png" alt="" /> {/* Ensure image paths are correct */}
              <div className="user-info">
                <h3>Anil Bansal</h3>
                <span>happy customer</span>
              </div>
            </div>
            <span className="fas fa-quote-right"></span>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <h1 className="heading"> <span> contact </span> us </h1>
        <div className="row">
          {/* Contact Form - Ensure 'action' attribute or onSubmit handler is set up if form submission is needed */}
          <form action="">
            <p>Name</p>
            <input type="text" placeholder="name" className="box" required/>
            <p>Email</p>
            <input type="email" placeholder="example@gmail.com" className="box" required/>
            <p>Phone</p>
            <input type="tel" placeholder="+91 9876543210" className="box" required/> {/* Use type="tel" */}
            <p>Enquire about</p>
            <input type="text" placeholder="Enter Product Name or SKU (Optional)" className="box" />
            <p>Detail your requirement</p>
            <textarea name="message" className="box" placeholder="Message" id="contact-message" cols="30" rows="10" required></textarea>
            <input type="submit" value="send message" className="btn" />
          </form>
          {/* Map Section */}
          <div className="image"> {/* Consider renaming class to map-container */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d424.17504331520297!2d77.00579470854763!3d28.43785140160657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d190328eb88d5%3A0x45f550de869d868a!2sAMCO%20INDUSTRIES!5e0!3m2!1sen!2sin!4v1743834332104!5m2!1sen!2sin" // Ensure the src URL is correct
              width="100%" // Make width responsive
              height="450"
              style={{ border: 0 }} // Use style object for inline styles
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Amco Industries Location Map" // Add title for accessibility
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;